'use client';

import { DiscountCouponProvider } from '@/context/DiscountCouponProvider';
import { InPersonTokenProvider } from '@/context/InPersonTokenProvider';
import { TrackingTokenProvider } from '@/context/TrackingTokenProvider';
import { Suspense } from 'react';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense>
        <TrackingTokenProvider>
          <DiscountCouponProvider>
            <InPersonTokenProvider>
              <main>{children}</main>
            </InPersonTokenProvider>
          </DiscountCouponProvider>
        </TrackingTokenProvider>
      </Suspense>
    </>
  );
}
